"use client";

import { useFavorites } from "@/contexts/frontend/favorites-context";
import { useMemo } from "react";

export function FavoritesCountBadge() {
	const favorites = useFavorites();

	const favoriteCount = useMemo(() => {
		return Object.values(favorites?.favorites ?? {}).reduce((total, ids) => total + ids.length, 0);
	}, [favorites]);

	if (favoriteCount <= 0) return null;

	return (
		<span className="ms-favorites-count-badge absolute bg-(--ms-color-primary) text-(--ms-color-primary-fg) -top-1 -right-1 flex min-w-5 h-5 items-center justify-center text-xs rounded-full px-1">
			{favoriteCount}
		</span>
	);
}
